/**
 * A path on this origin, or undefined when `path` would leave it.
 *
 * `window.location.pathname` keeps a leading double slash, so for
 * `https://<app>//evil.example/x` the path is `//evil.example/x`, which the URL parser
 * resolves to `https://evil.example/x`. A return path built from the location has to be
 * checked before it is stored for the trip through the identity provider.
 */
export function sameOriginPath(path) {
    if (!path)
        return undefined;
    try {
        const target = new URL(path, window.location.origin);
        if (target.origin !== window.location.origin)
            return undefined;
        return `${target.pathname}${target.search}${target.hash}`;
    }
    catch (_a) {
        return undefined;
    }
}
/** The current location as a same-origin path, or undefined when it cannot be expressed as one. */
export function currentLocationPath() {
    return sameOriginPath(`${window.location.pathname}${window.location.search}${window.location.hash}`);
}
//# sourceMappingURL=returnTo.js.map